<template>
    <div class="event">
        <van-nav-bar left-arrow @click-left="back"></van-nav-bar>

        <Banner />

        <div class="event-title">是否参观12号人工智能主题馆</div>
        <div class="event-title-box" v-if="isSign">

            <div class="event-submit" @click="onSubmit">点击报名</div>
        </div>

        <div class="sign-prompt" v-else>
            <div class="sign-prompt-box">
                <div class="sign-prompt-title">已报名</div>
                <div class="sign-prompt-content">
                    <svg-icon icon-name="success" icon-class="success" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
import Banner from '@/components/Common/banner';
export default {
    name: 'event',
    data() {
        return {
            userData: null,
            isSign: false,
        };
    },
    components: {
        Banner,
    },
    created() {
        this.handleGetUserInfo();
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        handleGetUserInfo() {
            this.$toast.loading({
                message: '数据加载中...',
                forbidClick: true,
                loadingType: 'spinner',
            });
            httpRequest
                .get(`/api/visitor/getInfo`)
                .then(res => {
                    const { code, data, msg } = res.data;

                    if (code == 200) {
                        this.userData = data;
                        if (data.custom1 === null || data.custom1 === '不参观') {
                            this.isSign = true;
                        } else {
                            this.isSign = false;
                        }
                    } else {
                        this.isSign = true;
                    }
                })
                .catch(error => {})
                .finally(() => {
                    this.$toast.clear();
                });
        },

        onSubmit() {
            var loadingToast = this.$toast.loading({
                message: '数据加载中...',
                forbidClick: true,
                loadingType: 'spinner',
            });
            let params = { ...this.userData };
            params.custom1 = '参观';
            httpRequest
                .put(`/api/visitor`, params)
                .then(res => {
                    const { code, data, msg } = res.data;
                    loadingToast.clear();
                    if (code == 200) {
                        this.$toast.success('报名成功');
                        this.handleGetUserInfo();
                    } else {
                        this.$router.push({
                            path: '/login',
                            query: {
                                source: this.$route.query.source,
                                companyId: this.$route.query.companyId,
                                companyShareId: this.$route.query.companyShareId,
                                teamId: this.$route.query.teamId,
                            },
                        });
                    }
                })
                .catch(error => {
                    loadingToast.clear();
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.event {
    .event-title {
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
    }
    .event-title-box {
        display: flex;
        justify-content: center;

        .event-submit {
            margin-top: 12px;
            text-align: center;
            padding: 10px 0;
            background: #2062f9;
            width: 33.33%;
            border-radius: 5px;
            color: #fff;
        }
    }
    .sign-prompt {
        padding-top: 30px;
        .sign-prompt-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .sign-prompt-title {
                font-weight: bold;
                font-size: 16px;
                margin-bottom: 12px;
            }
            .sign-prompt-content {
                font-size: 90px;
            }
        }
    }
}
</style>